import type { ReportCatalog } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

export const useReportCatalogKey = "reportCatalog";

export const useReportCatalog = (enabled = true) =>
  useQuery<ReportCatalog>({
    queryKey: [useReportCatalogKey],
    queryFn: async () => {
      const { result } = await api.client.reporting.getCatalog();
      if (!result) {
        throw new Error("empty reporting catalog response");
      }
      return result;
    },
    enabled,
    staleTime: 5 * 60 * 1000
  });
